// extracted by mini-css-extract-plugin
export default {"secondary-nav":"src-assets-style-scss-___navigation__secondary-nav___JcaXy"};